import { render, staticRenderFns } from "./GeneratorCategoryInput.vue?vue&type=template&id=da664128&scoped=true&"
import script from "./GeneratorCategoryInput.vue?vue&type=script&lang=js&"
export * from "./GeneratorCategoryInput.vue?vue&type=script&lang=js&"
import style0 from "./GeneratorCategoryInput.vue?vue&type=style&index=0&id=da664128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da664128",
  null
  
)

export default component.exports